import { memo } from "react";
import { getErrorLogIds } from "@timeedit/registration-shared";
import { Typography } from "@timeedit/ui-components";
type ErrorLogIdProps = {
  error: unknown;
};

export const ErrorLogId = memo(function ErrorLogId({ error }: ErrorLogIdProps) {
  const logIds = getErrorLogIds(error);
  if (logIds.length === 0) return null;
  if (!Array.isArray(logIds) || logIds.length === 1) {
    return (
      <Typography.Text className="error-log-id__text-container">
        Log Id: {logIds}
      </Typography.Text>
    );
  }

  return (
    <div className="error-log-id__text-container">
      <Typography.Text>Log ids: </Typography.Text>
      <br />
      {logIds.map((logId) => (
        <div key={logId}>
          <Typography.Text>{logId}</Typography.Text>
          <br />
        </div>
      ))}
    </div>
  );
});
